class SearchView {
  _parentEl = document.querySelector('.search');

  getQuery() {
    const query = this._parentEl.querySelector('.search__field').value;
    this._clearInput();
    return query;
  }

  _clearInput() {
    this._parentEl.querySelector('.search__field').value = '';
  }

  addHandlerSearch(handler) {
    this._parentEl.addEventListener('submit', function (e) {
      //used submit instead of click so that this will work whether user clicks or presses enter
      e.preventDefault(); //prevents the page from reloading on submit
      handler();
    });
  }
}

export default new SearchView();
